import { useEffect, useState } from "react";
import { handleSSOCallback } from "@speedycore/identity-client/sso";
import {
  IdentityA11yAnnouncer,
  IdentityError as IdentityErrorView,
  IdentityFooterInline,
  IdentityHero,
  IdentityLayout,
  IdentitySSOStatus,
} from "@speedycore/identity-ui";
import { sendIdentityTelemetry } from "../lib/identityApi";

export function SsoCallbackPage() {
  const [error, setError] = useState<string | null>(null);
  const [stage, setStage] = useState<"callback" | "complete">("callback");

  useEffect(() => {
    let cancelled = false;
    const safeDefault = (() => {
      if (typeof window === "undefined") return "https://dashboard.speedycore.com.au/";
      try {
        const params = new URLSearchParams(window.location.search);
        const explicit = params.get("redirect_uri");
        if (explicit) return explicit;
        const stored = window.localStorage.getItem("speedycore_return_url");
        if (stored) return stored;
      } catch (_) {
        /* ignore */
      }
      return window.location.origin;
    })();
    void handleSSOCallback({
      defaultRedirect: safeDefault,
    }).then((result) => {
      if (cancelled) return;
      if (!result.ok && result.error) {
        setError(result.error);
        void sendIdentityTelemetry("identity.sso_callback_error", {
          error_code: "sso_callback_failed",
        });
      } else {
        setStage("complete");
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <IdentityA11yAnnouncer message={error ?? ""} type="error" />
      <IdentityLayout
        hero={
          <IdentityHero
            title={stage === "complete" ? "You're signed in." : "Completing secure login…"}
            subtitle={stage === "complete" ? "Your SpeedyCore session is active — no need to sign in again." : "Signing in with SpeedyCore Identity…"}
          />
        }
        form={
          <>
            {error ? (
              <IdentityErrorView message={error} />
            ) : (
              <IdentitySSOStatus stage={stage} />
            )}
            <IdentityFooterInline />
          </>
        }
      />
    </>
  );
}
